import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';

interface NCFileDetailsNCFilePerformanceActiveProps {}

const NCFileDetailsNCFilePerformanceActiveComponent: FC<NCFileDetailsNCFilePerformanceActiveProps> = ({
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  getNCFileById,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <EventChartsInnerComponent {...props} />} />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFilePerformanceActive = connect(({}) => ({}), {
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsNCFilePerformanceActiveComponent);

export { NCFileDetailsNCFilePerformanceActive };
